import { Id, LaravelResponse, ModelUsageResource, createCrudService, keyToUrl } from "@dgs/core";
import axios from "axios";
import { TenantIndexResource, TenantOptionResource } from "../../../../shared/types/tenant";
import { SelectedTenantResponse, TenantSaveRequest, TenantUpdateResource } from "../types/tenant";

const baseKey = "tenants";
const selectedKey = [baseKey, "selected"];
const getDefaultKey = [baseKey, "default"];
const selectKey = (tenantId: Id) => [baseKey, `${tenantId}`, "select"];
const showUsageKey = (tenantId: Id) => [baseKey, `${tenantId}`, "usage"];

const allOptionsKey = [baseKey, "options", "all"];

const baseService = createCrudService<
	TenantIndexResource,
	TenantOptionResource,
	TenantUpdateResource,
	TenantSaveRequest
>([baseKey]);

export const tenantService = {
	...baseService,
	selected: () => axios.get<LaravelResponse<SelectedTenantResponse>>(keyToUrl(selectedKey)),
	selectedKey,
	select: (id: Id) => axios.put<LaravelResponse<void>>(keyToUrl(selectKey(id)), { selected: true }),
	selectKey,
	showUsage: (tagId: Id) => axios.get<LaravelResponse<ModelUsageResource[]>>(keyToUrl(showUsageKey(tagId))),
	showUsageKey,
	getDefault: () => axios.get<LaravelResponse<TenantOptionResource>>(keyToUrl(getDefaultKey)),
	getDefaultKey,
	allOptions: () => axios.get<LaravelResponse<TenantOptionResource[]>>(keyToUrl(allOptionsKey)),
	allOptionsKey,
};
